/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(Class) {

	const METHODS = {
		API_METHODS: [
			'getId',
			'getChildren',
			'render',
			'getSelfRatio',
			'getParentLayout',
			'getWidgetAPI'
		]
	};

	const LayoutAPI = Class.extend({

		model: null,
		controller: null,

		/**
		 * Constructor
		 *
		 * @param {LayoutController} controller - layout controller
		 */
		init: function(controller) {
			this.model = controller.model;
			this.controller = controller;
			this.layoutController = controller.layoutController;
		},

		/**
		 * Layout id getter
		 * @return {string} layout id
		 */
		getId: function() {
			return this.model.id;
		},

		/**
		 * Get layout children
		 *
		 * @return {LayoutAPI[]} array of children layout APIs
		 */
		getChildren: function() {
			return this.model.items
				.map(({ id }) => {
					const layout = this.layoutController.getView(id);
					if (layout && layout.view && layout.view.getAPI) {
						return layout.view.getAPI();
					}
				})
				.filter(item => !!item);
		},

		/**
		 * Show layout
		 *
		 * @param {object} options - Rendering Options
		 *	Supported options:
		 *	isBackgroundRun:true|false // Indicate that the rendering is non-interactive (for use by thumbnails)
		 *
		 */
		render: function(options) {
			this.controller.render(options);
		},

		/**
		 * Get layout ratio from parent layout
		 * @return {Object} ratio; has properties `width` and `height` with the appropriate ratios
		 */
		getSelfRatio: function() {
			return this.controller.getSelfRatio();
		},

		/**
		 * Get parent layout API
		 *
		 * @return {Object}
		 */
		getParentLayout: function() {
			return this.controller.getParentLayout();
		},

		/**
		 * Get widget API
		 *
		 * @return {WidgetAPI} widget API
		 */
		getWidgetAPI: function() {
			return this.controller.widgetAPI;
		}
	});

	LayoutAPI.API_METHODS = METHODS.API_METHODS;

	return LayoutAPI;

});
